// 3rd party
import * as React from "react";
import { Maybe } from "tsmonad";

// Components
import { AboutArea } from "@src/presentation/components/aboutArea";

// Domain
import * as domain from "@src/domain";

// Styles
import { useModuleContainerStyles } from "./styles";

export { ModuleContainer };

interface ModuleContainerProps {
	maybeModule: Maybe<domain.Module>;
	productInfo: domain.ProductInfo;
}

const ModuleContainer = ({
	maybeModule,
	productInfo,
}: ModuleContainerProps): JSX.Element => {
	const classes = useModuleContainerStyles();

	return maybeModule.caseOf({
		just: (module: domain.Module): JSX.Element => {
			if (module.origin === "external") {
				return (
					<iframe
						className={classes.iframe}
						title={module.name}
						src={module.url}
					/>
				);
			} else {
				if (module.url === "about") {
					return <AboutArea version={productInfo.version} />;
				} else {
					return <></>;
				}
			}
		},
		nothing: (): JSX.Element => (
			<div className={classes.emptyText}>
				Please select an option from the list at the left
			</div>
		),
	});
};
